import { ClubRegisterData, ClubRegisterRequestData, Director } from 'store/clubs/types/types';
import { Address } from 'components/NetworkRegister/NetworkRegisterInterface/NetworkRegisterInterface';

const mapDirectors = (directors: Director[]) =>
  directors.map((director: Director) => ({
    title: director.title,
    first_name: director.firstName,
    middle_name: director.middleName,
    surname: director.surname,
    date_of_birth: director.dateOfBirth,
    gender: director.gender,
    addresses: director.addresses.map((address: Address) => ({
      post_code: address.postCode.toString().toUpperCase(),
      house_number: address.houseNr,
      street_line_1: address.line1 || '',
      street_line_2: address.line2 || '',
      city: address.city,
      county: address.county,
      resident_from_date: address.residentFrom,
    })),
  }));

const exportObject = {
  map: (clubDetails: ClubRegisterData, directors: Director[]): ClubRegisterRequestData => {
    return {
      name: clubDetails.clubName,
      post_code: clubDetails.postcode.toUpperCase(),
      house_number: clubDetails.houseNumber,
      street_line_1: clubDetails.addressLine1,
      street_line_2: clubDetails.addressLine2,
      city: clubDetails.city,
      county: clubDetails.county,
      email: clubDetails.email,
      phone_number: clubDetails.telephoneNumber,
      commission_term_id: clubDetails.commissionTerms,
      account_sort_code: clubDetails.sortCode,
      account_number: clubDetails.accNumber,
      account_name: clubDetails.accName,
      directors: mapDirectors(directors),
    };
  },
};

export default exportObject;
